import React from "react";
import type { FC } from "react";

import { Counter } from "../../../../Counter/Counter";

import type { PropsWithCustomColorsStyles } from "../../../../../types/react";
import type {
    CounterProps,
    CounterPropsRegularSize,
} from "../../../../Counter/Counter";

const CHIP_CHOICE_COUNTER_TEST_ID = "chip-choice-counter-test-id";

interface IChipCounterMain extends Pick<CounterProps, "size"> {}

interface IChipCounter
    extends Pick<CounterPropsRegularSize, "quantity">,
        Partial<PropsWithCustomColorsStyles> {}

export const ChipCounter: FC<IChipCounter> = (props) => {
    const { customColorsStyles = "", ...restProps } = props as IChipCounter &
        IChipCounterMain;

    return (
        <Counter
            {...restProps}
            customColorsStyles={customColorsStyles}
            size="16"
            view="custom"
            data-tsid={CHIP_CHOICE_COUNTER_TEST_ID}
        />
    );
};

ChipCounter.displayName = "ChipChoice.Counter";

export default ChipCounter;
